import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const navBar = css({
  background: colorsPalette.white,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: NAV_MAX_HEIGHT_SMALL_VIEWPORT,
  [MediaQueries.mdAndUp]: {
    height: NAV_MAX_HEIGHT,
  },
});

export const exit = css(typography.effra16, {
  alignItems: 'center',
  background: colorsPalette.transparent,
  border: 'none',
  color: colorsPalette.black,
  cursor: 'pointer',
  display: 'flex',
  padding: 0,
});

export const exitIcon = css({
  fontSize: 16,
  marginRight: 3,
  width: 18,
  height: 18,
  display: 'inline-block',
  '&:before': {
    transform: 'rotate(85deg)',
    position: 'absolute',
    left: -4,
  },
});

export const buttonReset = css({
  background: 'none',
  border: 'none',
  padding: 0,
  textDecoration: 'none',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const regusLogo = css({
  fontSize: 30,
  pointerEvents: 'none',
  [MediaQueries.mdAndUp]: {
    fontSize: 38,
  },
});

export const flexWrapper = css({
  display: 'flex',
  alignItems: 'center',
  color: 'inherit',
  cursor: 'pointer',
});

export const rightContent = css({
  position: 'absolute',
  top: '50%',
  right: 0,
  transform: 'translateY(-50%)',
});

export const getInTouch = css(typography.effra16, {
  fontWeight: fontWeights.medium,
  color: colorsPalette.black,
  minWidth: 'unset',
  width: 'auto',
  paddingBottom: 3,
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  marginRight: 16,
  padding: 0,
  textTransform: 'none',
  background: colorsPalette.transparent,
  display: 'inline-block',
  height: '100%',
  '&:hover, &:focus, &:active': {
    background: colorsPalette.transparent,
    outline: 'none',
    borderBottom: `1px solid ${colorsPalette.grey60}`,
  },

  [MediaQueries.md]: {
    marginRight: 0,
  },
});

export const phoneNumber = css(typography.effra16, {
  color: colorsPalette.black,
  '&:visited, &:link': {
    textDecoration: 'none',
  },
  '&:hover': {
    fontWeight: fontWeights.medium,
  },
});

export const startOverCta = css({
  color: colorsPalette.black,
  cursor: 'pointer',
  paddingLeft: 26,
  position: 'relative',
  '&:visited, &:link': {
    textDecoration: 'none',
  },
  '&:hover, &:focus, &:active': {
    '.text': {
      borderBottom: `1px solid ${colorsPalette.grey60}`,
    },
  },
});

export const startOverCtaIcon = {
  left: 0,
  position: 'absolute',
  top: 2,
};

export const startOverCtaCopy = css({
  borderBottom: `1px solid ${colorsPalette.grey20}`,
  paddingBottom: 3,
});
